import { css } from '@linaria/core';
import { baseTheme, breakpoints } from 'styles/utils';
export const container = "odules__Home__CodeSnippet__CodeSnippet_styles_ts-container-c1cbusi";
export const header = "odules__Home__CodeSnippet__CodeSnippet_styles_ts-header-h1qbb4us";
export const codePreview = "odules__Home__CodeSnippet__CodeSnippet_styles_ts-codePreview-c1mgpaet";

require("./CodeSnippet.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./CodeSnippet.styles.ts");